import { render, staticRenderFns } from "./appointment-cancel-popup.vue?vue&type=template&id=96b182d8&scoped=true&"
import script from "./appointment-cancel-popup.vue?vue&type=script&lang=js&"
export * from "./appointment-cancel-popup.vue?vue&type=script&lang=js&"
import style0 from "./appointment-cancel-popup.vue?vue&type=style&index=0&id=96b182d8&scoped=true&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b182d8",
  null
  
)

export default component.exports